import React from "react";
import "./foodListStyle.css";
import { Assort } from "../../../models/Assort";
import { AssortGroup } from "../../../models/AssortGroup";
import { useTranslation } from "react-i18next";

interface IProps {
  activeGroup: AssortGroup;
  foodList: Assort[];
  handleAddBasket: Function;
}

const FoodList: React.FC<IProps> = ({ foodList, activeGroup, handleAddBasket }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className={"food-list-wrapper"}>
      <h3>{activeGroup.name}</h3>
      <div className={"food-list-container"}>
        {foodList.map((value: Assort, index: number) => (
          <div className={"food-container"} key={index}>
            <div className={"food-img"}>
              <img src={value.picture} alt={value.name} />
            </div>
            <div className={"food-info"}>
              <p>{value.name}</p>
              <p>{priceFormatter(value.price)}</p>
            </div>
            <button className={"food-add-btn"} onClick={() => handleAddBasket(value)}>
              <span>{t("dodaj_do_koszyka")}</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FoodList;

const priceFormatter = (value: number) => {
  const priceTab = value.toFixed(2).split(".");
  return (
    <React.Fragment>
      <span>{priceTab[0]}</span>
      <span>{priceTab[1]}</span>
    </React.Fragment>
  );
};
